export class User {
    id: number;
    email: string;
    password: string;
    token: string;
}
export interface UserModel {
    avatar: string
    _id: string
    email: string
    first_name: string
    last_name: string
    gender: string
    verification_token: string
}